// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"447e1da6","977":"d09af86f"}[chunkId] + ".chunk.js";
};